import React, { useContext, useEffect, useState } from "react";
import AdminStyle from "../assets/css/layouts/AdminStyle.css";
import {
  //BrowserRouter as Router,

  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import PageContent from "../components/admin/menus/PageContent";
import ModalMsm from "../components/general/ModalMsm";
import { GlobalContext } from "../contexts/GlobalContext";
import LoaderSpinner from "../components/general/LoaderSpinner";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Routes from "../Routes";
import ModalPublishProduct from "../components/admin/productos/amazon/ModalPublishProduct";
import MultiplePost from "../components/admin/productos/amazon/MultiplePost";
import AnotherMenu from "../components/admin/menus/AnotherMenu";
import ProviderSidebarWrapper from "../components/client/sidebar/ProviderSidebarWrapper";
//import ModalLinkCategories from "../components/admin/categories/ModalLinkCategories";
//import ModalTranslateCategories from "../components/admin/categories/ModalTranslateCategories";
import SelectCategory from "../components/admin/productos/mercado-libre/rangos-publicacion/rangos-step/SelectCategory";
import DefaultimgPost from "../components/admin/productos/amazon/DefaultimgPost";
import InfoIcons from "../components/admin/productos/amazon/InfoIcons";
import ModalTracking from "../components/admin/productos/orders/components/ModalTracking";
import ModalLinkCity from "../components/admin/city/ModalLinkCity";
import ListProcess from "../components/admin/offline-process/views/ListProcess";
import ModalPublisInAnotherStore from "../components/admin/productos/product/ModalPublisInAnotherStore";
import VerifyLogin from "../components/general/VerifyLogin";
import ModalAddProductFtp from "../components/admin/productos/product/components/ModalAddProductFtp";
import ModalSelectStoreAndSection from "../components/admin/productos/public-products-m-to-m/components/py/ModalSelectStoreAndSection";
import ModalLinkProduct from "../components/admin/productos/public-products-m-to-m/components/py/ModalLinkProduct";
import ModalPostProduct from "../components/admin/productos/public-products-m-to-m/components/ModalPostProduct"
import FiltersGrid from "../components/admin/productos/orders/components/FiltersGrid";
import ReportPostproductsByUser from "../components/admin/reports/amazon/ReportPostproductsByUser";
import ModalOtherMarketplace from "../components/admin/productos/amazon/modal-other-marketplace/ModalOtherMarketplace";
import ModalTestFilter from "../components/admin/filters/views/ModalTestFilter";
import { userRole } from '../assets/js/SessionStorageNames'
import verifyAccessRole from "../assets/js/verifyAccessRole";
require("../assets/js/axiosInterceptor");

function Admin() {
  const globalContext = useContext(GlobalContext);
  const [role, setRole] = useState(localStorage.getItem(userRole));
  
  // Efecto para sincronizar el role con localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      setRole(localStorage.getItem(userRole));
    };

    // Verificar cambios en localStorage
    const currentRole = localStorage.getItem(userRole);
    if (currentRole !== role) {
      setRole(currentRole);
    }

    // Escuchar cambios en localStorage
    window.addEventListener('storage', handleStorageChange);
    
    // Interval para verificar cambios (fallback)
    const interval = setInterval(() => {
      const currentRole = localStorage.getItem(userRole);
      if (currentRole !== role) {
        setRole(currentRole);
      }
    }, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [role]);

  const hasAccess = verifyAccessRole(Routes, 86);
  
  const switchRoutes = (
    <Switch>
      {
        Routes.map((val, key) => {
          if (val.layout === "/admin") {
            return (
              <Route
                path={val.layout + val.path}
                component={val.component}
                key={key}
                />
                );
              }
              return null;
          }
        )
      }
      {role === "Scanner" ? 
        <Redirect from="/admin" to="/admin/scanner" />
        : role === "Proveedor" ?
        <Redirect from="/admin" to="/admin/client/dashboard" />
        :
        <Redirect from="/admin" to="/admin/dashboard" />
      }
    </Switch>
  );

  const LoaderPage = () => {
    if (globalContext.loaderPage) {
      return (
        <div className="spinnerLoader d-flex justify-content-center align-items-center active">
          <LoaderSpinner />
        </div>
      );
    }
  };

  return (
    <>
      {!hasAccess
        ? role === "Scanner"
          ? <Redirect from="/admin" to="/admin/scanner" />
          : role === "Proveedor"
          ? <Redirect from="/admin" to="/admin/client/dashboard" />
          : <Redirect from="/admin" to="/admin/dashboard" />
        : null
      }
      <AdminStyle>
        <ModalMsm
          show={globalContext.modal.show}
          title={globalContext.modal.title}
          error={globalContext.modal.msg}
          config={globalContext.modal.config}
          handleClose={globalContext.modal.handleClose}
          txtButton="Cerrar"
        />
        {LoaderPage()}
        <div className="page-wrapper chiller-theme toggled" id="pageWrapper">
          <PageContent role={role}>
            {switchRoutes}
          </PageContent>
        </div>
      </AdminStyle>
      <ModalPublishProduct />
      <MultiplePost />
      {role === "Proveedor" ? <ProviderSidebarWrapper /> : <AnotherMenu />}
      
      <ModalLinkCity active={globalContext.activeModalLinkCity} setActive={globalContext.setActiveModalLinkCity} cityText={globalContext.cityText} cityId={globalContext.cityId} cityDataOdoo={globalContext.cityDataOdoo}/>
      <SelectCategory active={globalContext.activeModalMlAm} setActive={globalContext.setActiveModalMlAm} />
      <ListProcess active={globalContext.activeModalProcces} />
      <ModalPublisInAnotherStore active={globalContext.activeModalPublicOtherStore} />
      <InfoIcons />
      <ModalTracking />
      <DefaultimgPost />
      <VerifyLogin />
      <ModalAddProductFtp />
      <ModalSelectStoreAndSection />
      <ModalLinkProduct />
      <ModalPostProduct />
      <FiltersGrid />
      <ReportPostproductsByUser />
      <ModalOtherMarketplace />
      <ModalTestFilter />
    </>
  );
}

export default Admin;